import React from 'react';
import { ExcelLikeSmartGrid } from '../../components/ControlBridge/SmartGrid/ExcelLikeSmartGrid';

interface SmartGridProps {
  entity?: string;
  sheetName?: string;
  className?: string;
}

export const SmartGrid: React.FC<SmartGridProps> = ({
  entity = 'tasks',
  sheetName = 'default',
  className
}) => {
  return (
    <div className={className}>
      <ExcelLikeSmartGrid
        entityId={entity}
        className="h-full"
      />
    </div>
  );
};

export default SmartGrid;
